import { Card, DatePicker, Select, InputNumber, Button, Table, Space, message } from 'antd'
import { FileSearchOutlined } from '@ant-design/icons'
import { useState } from 'react'
import axios from 'axios'
import dayjs from 'dayjs'

const { RangePicker } = DatePicker

function IncomeStatementReport() {
  const [dateRange, setDateRange] = useState([dayjs().startOf('year'), dayjs()])
  const [stock, setStock] = useState(1)   // افتراضي: من المستودعات
  const [dep, setDep] = useState(1)       // افتراضي: من التقرير
  const [level, setLevel] = useState(1)
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState([])

  const token = localStorage.getItem('token')
  const headers = { Authorization: `Bearer ${token}` }

  const fetchReport = async () => {
    setLoading(true)
    try {
      const params = {
        date_from: dayjs(dateRange[0]).format('YYYY-MM-DD'),
        date_to: dayjs(dateRange[1]).format('YYYY-MM-DD'),
        stock,
        dep,
        level
      }
      const res = await axios.get('/api/settings/income-statement/report', { headers, params })
      setRows(res.data)
    } catch (err) {
      message.error(err.response?.data?.error || 'خطأ في جلب تقرير قائمة الدخل')
    }
    setLoading(false)
  }

  const columns = [
    { title: <span style={{ color: '#1c599e' }}>رمز الحساب</span>, dataIndex: 'acCode', key: 'acCode', width: 110,
      render: v => <strong>{v}</strong> },
    { title: <span style={{ color: '#1c599e' }}>اسم الحساب</span>, dataIndex: 'acName', key: 'acName' },
    { title: <span style={{ color: '#1c599e' }}>اسم الحساب اللاتيني</span>, dataIndex: 'acLatinName', key: 'acLatinName',
      render: v => v || <span style={{ color: '#ccc' }}>—</span> },
    { title: <span style={{ color: '#1c599e' }}>مدين</span>, dataIndex: 'Debit', key: 'Debit', align: 'left',
      render: v => (v || 0).toLocaleString() },
    { title: <span style={{ color: '#1c599e' }}>دائن</span>, dataIndex: 'Credit', key: 'Credit', align: 'left',
      render: v => (v || 0).toLocaleString() },
    { title: <span style={{ color: '#1c599e' }}>الرصيد</span>, dataIndex: 'Bal', key: 'Bal', align: 'left',
      render: v => <strong style={{ color: v < 0 ? '#ff4d4f' : '#0f8a45' }}>{(v || 0).toLocaleString()}</strong> },
    { title: <span style={{ color: '#1c599e' }}>سابق مدين</span>, dataIndex: 'PrevDebit', key: 'PrevDebit', align: 'left',
      render: v => (v || 0).toLocaleString() },
    { title: <span style={{ color: '#1c599e' }}>سابق دائن</span>, dataIndex: 'PrevCredit', key: 'PrevCredit', align: 'left',
      render: v => (v || 0).toLocaleString() },
  ]

  return (
    <div>
      <Card style={{ marginBottom: 16 }}>
        <Space size="middle" wrap align="end">
          <div>
            <div style={{ fontSize: 12, color: '#1c599e', fontWeight: 600, marginBottom: 4 }}>الفترة</div>
            <RangePicker value={dateRange} onChange={setDateRange} />
          </div>

          <div>
            <div style={{ fontSize: 12, color: '#1c599e', fontWeight: 600, marginBottom: 4 }}>البضاعة</div>
            <Select
              value={stock}
              style={{ width: 180 }}
              onChange={setStock}
              options={[
                { label: 'من المستودعات', value: 1 },
                { label: 'القيم الافتراضية', value: 2 },
                { label: 'سندات القيد', value: 3 },
              ]}
            />
          </div>

          <div>
            <div style={{ fontSize: 12, color: '#1c599e', fontWeight: 600, marginBottom: 4 }}>الإهلاكات</div>
            <Select
              value={dep}
              style={{ width: 160 }}
              onChange={setDep}
              options={[
                { label: 'من التقرير', value: 1 },
                { label: 'من سندات القيد', value: 0 },
              ]}
            />
          </div>

          <div>
            <div style={{ fontSize: 12, color: '#1c599e', fontWeight: 600, marginBottom: 4 }}>المستوى</div>
            <InputNumber
              value={level}
              onChange={setLevel}
              min={1}
              style={{ width: 100 }}
            />
          </div>

          <div>
            <div style={{ fontSize: 12, marginBottom: 4 }}>&nbsp;</div>
            <Button type="primary" icon={<FileSearchOutlined />} loading={loading} onClick={fetchReport}>
              عرض التقرير
            </Button>
          </div>
        </Space>
      </Card>

      <Card title={<span style={{ color: '#1c599e' }}>قائمة الدخل</span>}>
        <Table
          columns={columns}
          dataSource={rows}
          rowKey={(r, i) => i}
          pagination={{ pageSize: 30 }}
          size="small"
          scroll={{ x: 1100 }}
        />
      </Card>
    </div>
  )
}

export default IncomeStatementReport
